import { styled } from '@mui/system';
import { Typography, LinearProgress, Button } from '@mui/material';

interface CancelButton {
  disabled?: boolean;
}

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  '@media (min-width: 900px)': {
    height: 'calc(100vh - 100px)',
  },
});

const LoadingText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#414046',
  textAlign: 'center',
  margin: '0 100px 45px 100px',
  [theme.breakpoints.up(900)]: {
    margin: '0 300px 45px 300px',
  },
}));

const LoadingImg = styled('img')({
  width: '47.24px',
  marginBottom: '45px',
});

const LoadingBar = styled(LinearProgress)({
  width: '40%',
  height: '4px',
  borderRadius: '2px',
  backgroundColor: '#E5E5E5',
  '@media (min-width: 900px)': {
    width: '25%',
  },
});

const CancelButton = styled(Button)<CancelButton>(({ disabled }) => ({
  padding: '10px 20px',
  marginTop: '20px',
  cursor: 'pointer',
  borderRadius: '100px',
  color: '#FFFFFF',
  height: '42px',
  width: '199px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const CancelText = styled(Typography)({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  textDecoration: 'none',
  textTransform: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
});

export {
  RootDiv,
  LoadingText,
  LoadingImg,
  LoadingBar,
  CancelButton,
  CancelText,
};
